module.exports = __webpack_public_path__ + "img/engineering__table.9ad4484c.svg";